import React from 'react';
import '../styles/landing.css';
import Navigation from '../components/landing/Navigation';
import Hero from '../components/landing/Hero';
import TrustBadges from '../components/landing/TrustBadges';
import SevenFeatures from '../components/landing/SevenFeatures';
import BusinessTypes from '../components/landing/BusinessTypes';
import AppPricing from '../components/landing/AppPricing';
import FAQ from '../components/landing/FAQ';
import FinalCTA from '../components/landing/FinalCTA';
import Footer from '../components/landing/Footer';
import SEO from '../components/landing/SEO';

const LandingPage = () => {
  return (
    <div className="App min-h-screen" style={{ background: '#131313' }}>
      <SEO
        title="CONSAI - Voice-Powered AI Business App for Indian Small Businesses | Free Trial"
        description="Manage sales, stock & customer khatas with voice commands in Hindi or English. Get daily AI insights for your kirana, restaurant, salon or trading business. 14-day free trial. Starting ₹19/month."
        keywords="AI business app India, voice AI for business, kirana store app, sales tracking app India, stock management app India, customer khata app, Hindi voice AI, small business app India, CONSAI"
        canonical="https://consai.in/"
      />
      <Navigation />
      <Hero />
      <TrustBadges />
      <SevenFeatures />
      <BusinessTypes />
      <AppPricing />
      <FAQ />
      <FinalCTA />
      <Footer />
    </div>
  );
};

export default LandingPage;
